import { useEffect } from "react";
import { COLORS } from "@/constants";
import { trackEvent } from "@/utils/helper/error-reporter";

// Rendered from main.tsx (outside App and all providers) when no tenant id
// could be resolved from the entry link or a previous visit. Opening the app
// through the fitness club's LINE account delivers the tenant id and recovers
// this state permanently.
export const TenantNotFoundScreen = () => {
  // A member landing here is locked out until they reopen from LINE; count it.
  useEffect(() => {
    trackEvent("TenantNotFound", { hostname: globalThis.location.hostname });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100dvh",
        padding: 24,
        textAlign: "center",
        color: COLORS.text.pagePrimary,
        backgroundColor: COLORS.background.bodyDefault,
      }}
    >
      <div style={{ fontSize: 20, fontWeight: 700 }}>ไม่พบข้อมูลฟิตเนส</div>
      <div>กรุณาเปิดแอปอีกครั้งจากบัญชี LINE Official ของฟิตเนสของคุณ</div>
      <div style={{ fontSize: 13, opacity: 0.7 }}>
        Fitness not found — please open the app again from your fitness
        club&apos;s official LINE account.
      </div>
    </div>
  );
};
